import { useRef, useCallback } from "react";
import { TextPaperArtifact } from "./TextPaper";
import { DesktopState, Paper, TextPaper } from "./desktopState";
import { ImagePaperArtifact } from "./ImagePaperArtifact";

export function Pinboard({ desktopState, setDesktopState }: { desktopState: DesktopState; setDesktopState: (value: React.SetStateAction<DesktopState>) => void; }) {
  const pinboardRef = useRef<HTMLDivElement>(null);

  const handleCut = useCallback((paper: TextPaper, lineIdx: number) => {
    if (desktopState.tool !== "SCISSORS") return;
    let paperIdx = desktopState.pinboard.papers.findIndex(p => p.id === paper.id);
    let newPapers = [...desktopState.pinboard.papers];
    let preCut = paper.lines.slice(0, lineIdx + 1);
    let postCut = paper.lines.slice(lineIdx + 1);
    newPapers[paperIdx] = { ...paper, lines: preCut };
    let heightOffset = preCut.length * 17 + 16 * 2 + 17;
    newPapers.splice(paperIdx + 1, 0, { id: Math.random().toString(), type: "text", pos: [paper.pos[0], paper.pos[1] + heightOffset], lines: postCut });
    setDesktopState(desktopState => ({
      ...desktopState,
      pinboard: {
        ...desktopState.pinboard,
        papers: newPapers
      }
    }));
  }, [desktopState, setDesktopState]);

  const handleBin = useCallback((paper: Paper) => {
    if (desktopState.tool !== "BIN") return;
    setDesktopState(desktopState => ({
      ...desktopState,
      pinboard: {
        ...desktopState.pinboard,
        papers: desktopState.pinboard.papers.filter(p => p.id !== paper.id)
      }
    }));
  }, [desktopState, setDesktopState]);

  const updatePosition = useCallback((paper: Paper, pos: [number, number]) => {
    let foundPaper = desktopState.pinboard.papers.find(p => p.id === paper.id);
    if (!foundPaper) return;
    setDesktopState(desktopState => ({
      ...desktopState,
      pinboard: {
        ...desktopState.pinboard,
        papers: [
          ...desktopState.pinboard.papers.filter(p => p.id !== paper.id),
          {...foundPaper!, pos }
        ]
      }
    }));
  }, [desktopState, setDesktopState]);


  return <section ref={pinboardRef} className={`flex flex-col gap-4 p-4 h-screen absolute top-0 left-0`}>
    {desktopState.pinboard.papers.map((paper, index) => (
      paper.type == "image" ? (
        <ImagePaperArtifact
          key={paper.id}
          paper={paper}
          tool={desktopState.tool}
          onBin={handleBin}
          updatePosition={updatePosition} />
      ) : (
        <TextPaperArtifact
          key={paper.id}
          paper={paper}
          tool={desktopState.tool}
          onCut={handleCut}
          onBin={handleBin}
          updatePosition={updatePosition} />
      )
    ))}
  </section>;
}
